import 'babel-polyfill';
import 'isomorphic-fetch';
import React from 'react';
import ReactDOM from 'react-dom';
import 'assets/styles/index.css';
import 'react-quill/dist/quill.snow.css';
import App from './App';

const rootElement = document.getElementById('root');

// ReactDOM 18 syntax
ReactDOM.createRoot(rootElement).render(<App />);